import { render, staticRenderFns } from "./Cn-OilShxto.vue?vue&type=template&id=9bdea1da&scoped=true&"
import script from "./Cn-OilShxto.vue?vue&type=script&lang=js&"
export * from "./Cn-OilShxto.vue?vue&type=script&lang=js&"
import style0 from "./Cn-OilShxto.vue?vue&type=style&index=0&id=9bdea1da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bdea1da",
  null
  
)

export default component.exports